// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"1f3a2121","4574":"8f9231bf","5066":"57d5ace2","5384":"f2c41c06","7945":"aec78970"}[chunkId] + ".css";
};